import React from 'react';
import { Link } from 'react-router-dom';
import logoVertical from '../assets/images/logo-vertical.png';

export default function Footer() {
  return (
    <footer className="bg-wood text-cream-light">
      <div className="container-custom py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img src={logoVertical} alt="Del Sol Muebles" className="h-28 w-auto mb-6 brightness-0 invert opacity-90" />
            <p className="text-sm text-cream/60 leading-relaxed max-w-xs">
              Muebles para hogar y restaurantes fabricados con calidad y diseño mexicano.
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-gold mb-6">Navegación</h4>
            <ul className="space-y-3">
              {['Inicio', 'Colección', 'Restaurantes', 'Proyectos', 'Galería', 'Contacto'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Inicio' ? '/' : `/${item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`}
                    className="text-sm text-cream/60 hover:text-gold transition-colors duration-300"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-gold mb-6">Contacto</h4>
            <ul className="space-y-3 text-sm text-cream/60">
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-gold/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                And. Tonaltecas 200-L 21, Tonalá Centro, 45400 Tonalá, Jal., México
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-gold/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
                +52 33 3828 3729
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-gold/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
                info@delsolmuebles.com
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-gold mb-6">Horario</h4>
            <ul className="space-y-3 text-sm text-cream/60">
              <li>Lunes a Viernes</li>
              <li className="text-cream/80">10:00 AM - 6:00 PM</li>
              <li className="pt-2">Sábados y Domingos</li>
              <li className="text-cream/80">Cerrado</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-cream/40 tracking-wider">
            © {new Date().getFullYear()} Del Sol Muebles. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            {/* Social icons */}
            {['Instagram', 'Facebook', 'WhatsApp'].map((social) => (
              <a
                key={social}
                href="#!"
                className="text-cream/40 hover:text-gold transition-colors duration-300 text-xs tracking-wider"
                aria-label={social}
              >
                {social}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
